<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-9" v-if="EvaluationForm.initialized">
            <table class="table-bordered table-main border-left-0 border-right-0 table-full-width" style="width: 30%" cellpadding="20">
              <thead>
                <th>Total Awarded Score</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <textarea
                      class="form-control"
                      name="technical.total_score"
                      v-model="EvaluationForm.totalScore"
                      :error="getError('technical.total_score')"
                      v-validate="'required'"
                      style="font-size: 18px"
                      placeholder=""
                    >
                    </textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-3">
            <info-right></info-right>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group upload-field">
              <span class="file-caption" v-if="!EvaluationForm.files.technical.evaluation_report">UPLOAD EVALUATION REPORT</span>
              <upload-file
                v-if="EvaluationForm.initialized"
                v-model="EvaluationForm.files.technical.evaluation_report"
                class="upload-file"
                :file-data="EvaluationForm.files.technical.evaluation_report"
                :is-editable="EvaluationForm.isEditable"
                :is-evaluation="true"
                section="technical.evaluation_report"
                >
              </upload-file>
            </div>
          </div>
        </div>


      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';
  import {Select, Option} from 'element-ui';

  export default {
    components: {
      ApplicationInfo,
      InfoRight,
      CommentBox,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.technical) {
        EvaluationForm.files.technical = {};
      }
    },
  }
</script>
<style lang="scss" scoped>
  textarea {
    resize: vertical !important;
  }

  .upload-field
  {
    display: block;
    width: 100%;
    height: 45px;
    padding-left: 10px;
    border: 1px solid #ccc;
    margin-top: 40px;
    line-height: 45px;

    .file-caption
    {
      display: inline-block;
    }

    .upload-file
    {
      float: right;
    }
  }
</style>
